<template>
    <div class="login-container">
        <MyLoading :show="showMyLoading" loadingtext="登录中,请稍后..." />
    </div>
</template>

<script>
import { Token } from '../models/token'
import { setCookie } from '../utils/cookie'
import { Toast } from 'vant'
import { cache } from '../utils/cache'
import { mapState, mapMutations, mapActions } from 'vuex'
import MyLoading from '../components/my/Loading.vue'
import { CommonMixins } from '../components/mixins'

const token = new Token()

export default {
    name: 'Login',
    components: {
        MyLoading
    },
    mixins: [CommonMixins],
    data() {
        return {
            username: '',
            password: ''
        }
    },
    computed: {},

    created() {},
    mounted() {
        this.login()
    },
    beforeMount() {},
    methods: {
        login() {
            const code = this.$route.query.code || ''
            if (code) {
                console.log(1)
                this.getToken(code)
            } else {
                console.log(2)
                this.wechatLogin()
            }
        },
        wechatLogin() {
            token.veirfyRefreshToken(true).then(
                res => {
                    if (!res.isValid) {
                        token.wechatLogin()
                    } else {
                        this.$router.push({ path: '/' })
                    }
                },
                err => {
                    console.log(err)
                }
            )
        },
        async getToken(code) {
            const res = await token.getTokenFromServer(code, '', 102)
            cache.session('token', res.token)
            cache.set('refresh_token', res.refresh_token)
            this.$router.push({ path: '/' })
        }
    }
}
</script>
<style lang='stylus' scoped></style>
